import Player from './Player';
// @ts-ignore
import DefaultVimeoPlayer from '@vimeo/player';
class VimeoPlayer extends Player {
    constructor(element) {
        super(element);
        this.media = null;
        // @ts-ignore
        this.player = null;
        this.element.addEventListener('videoPlayer.loadScript', () => {
            this.media = this.element.querySelector('iframe');
            if (this.media) {
                this.player = new DefaultVimeoPlayer(this.media);
                this.onPlayerReady();
            }
        });
    }
    play() {
        if (this.player)
            this.player.play();
    }
    stop() {
        if (this.player)
            this.player.pause();
    }
    mute() {
        if (this.player)
            this.player.setMuted(true);
    }
    unmute() {
        if (this.player)
            this.player.setMuted(false);
    }
}
export default VimeoPlayer;
